import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {Button, Modal, Form, Alert} from "react-bootstrap";

function SyncSuccess({handleClose}) {
  return (
    <Alert variant='success' onClose={handleClose} dismissible>
      Success
    </Alert>
  )
}

function SyncErrors({handleClose, errors}) {
  console.log(errors);
  return (
    <Alert variant='danger' onClose={handleClose} dismissible>
      { errors.map((err) => {return (<>{err} <br/></>)}) }
    </Alert>
  )
}

export function SyncModal({ show, setShow, sync }) {
  const { t } = useTranslation();
  const [ status, setStatus ] = useState({status: "pending", errors: null});
  const [ apiEnvironment, setApiEnvironment ] = useState("production");
  const syncCall = ()=>{
    sync(
      { api_environment: apiEnvironment }
    ).then(() => {
      setStatus({status: "success", errors: null});
    }).catch(function (error) {
      setStatus({status: "errors", errors: error.response.data});
    })
  }
  const onEnvChange = (event) => {
    setApiEnvironment(event.target.value)
  };
  const handleClose = () => {
    setShow(false)
  }
  const handleAlertClose = () => {
    setStatus({status: "pending", errors: null});
  }
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('sync')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {status.status == 'success' && <SyncSuccess handleClose={handleAlertClose}/>}
        {status.status == 'errors' && <SyncErrors handleClose={handleAlertClose} errors={status.errors}/>}
        <Form.Group>
          <Form.Label>API environment</Form.Label>
          <Form.Control as="select" value={apiEnvironment} onChange={onEnvChange} custom>
            <option value="production">production</option>
            <option value="preprod">preprod</option>
          </Form.Control>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('cancel')}
        </Button>
        <Button variant="primary" onClick={syncCall}>
          {t('sync')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
